import { ExecuteAPIGet } from '../server-utils'
import { EndPoints } from '../endpoints'
import { GameModel } from '../../models/game-models'

export const GamesUtils = {
  GetAll: async function GetAll(pageNo?: number) {
    return await ExecuteAPIGet<GameModel[]>(EndPoints.Games.GetAll, `pageNo=${!pageNo ? 0 : pageNo}`)
  }
}
